import { HttpService } from "../../modules/shared/services/http.service";
import { 
	SubscriptionPlan, 
	SubscriptionPlanCreateDto, 
	SubscriptionPlanArea, 
	SubscriptionPlanAreaCreateDto,
	SubscriptionPlanAreaBulkCreateDto,
	SubscriptionPlanResponse,
	SubscriptionPlanAreaResponse
} from "../../modules/shared/model";

const headers = { "Content-Type": "application/json", "x-custom-lang": "en" } as const;

// Subscription Plans CRUD Functions
export const createSubscriptionPlan = async (data: SubscriptionPlanCreateDto): Promise<SubscriptionPlan> => {
	const response = await HttpService.post("api/v1/subscription-plans", data, headers, true);
	return response;
};

export const updateSubscriptionPlan = async (id: string, data: Partial<SubscriptionPlanCreateDto>): Promise<SubscriptionPlan> => {
	const response = await HttpService.patch(`api/v1/subscription-plans/${id}`, data, headers, true);
	return response;
};

export const getSubscriptionPlanById = async (id: string): Promise<SubscriptionPlan> => {
	const response = await HttpService.get(`api/v1/subscription-plans/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getSubscriptionPlans = async (query?: Record<string, string | number | boolean>): Promise<SubscriptionPlanResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/subscription-plans${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const deleteSubscriptionPlan = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/subscription-plans/${id}`, { "x-custom-lang": "en" }, true);
};

// Subscription Plan Areas CRUD Functions
export const createSubscriptionPlanArea = async (data: SubscriptionPlanAreaCreateDto): Promise<SubscriptionPlanArea> => {
	const response = await HttpService.post("api/v1/subscription-plan-areas", data, headers, true);
	return response;
};

export const updateSubscriptionPlanArea = async (id: string, data: Partial<SubscriptionPlanAreaCreateDto>): Promise<SubscriptionPlanArea> => {
	const response = await HttpService.patch(`api/v1/subscription-plan-areas/${id}`, data, headers, true);
	return response;
};

export const getSubscriptionPlanAreaById = async (id: string): Promise<SubscriptionPlanArea> => {
	const response = await HttpService.get(`api/v1/subscription-plan-areas/${id}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getSubscriptionPlanAreas = async (query?: Record<string, string | number | boolean>): Promise<SubscriptionPlanAreaResponse> => {
	const qs = new URLSearchParams();
	Object.entries(query || {}).forEach(([k, v]) => {
		if (v !== undefined && v !== null) qs.append(k, String(v));
	});
	const response = await HttpService.get(`api/v1/subscription-plan-areas${qs.toString() ? `?${qs}` : ""}`, true, { "x-custom-lang": "en" });
	return response;
};

export const getSubscriptionPlanAreasByPlan = async (planId: string): Promise<SubscriptionPlanArea[]> => {
	const response = await HttpService.get(`api/v1/subscription-plan-areas/plan/${planId}`, true, { "x-custom-lang": "en" });
	return response;
};

export const bulkCreateSubscriptionPlanAreas = async (data: SubscriptionPlanAreaBulkCreateDto): Promise<SubscriptionPlanArea[]> => {
	const response = await HttpService.post("api/v1/subscription-plan-areas/bulk", data, headers, true);
	return response;
};

export const deleteSubscriptionPlanArea = async (id: string): Promise<void> => {
	await HttpService.deleteRecord(`api/v1/subscription-plan-areas/${id}`, { "x-custom-lang": "en" }, true);
};

export const bulkUpdateSubscriptionPlanAreas = async (updates: Array<{ id: string; data: Partial<SubscriptionPlanAreaCreateDto> }>): Promise<SubscriptionPlanArea[]> => {
	const response = await HttpService.patch("api/v1/subscription-plan-areas/bulk", { updates }, headers, true);
	return response;
};

export const getSubscriptionPlansByType = async (typeId: number): Promise<SubscriptionPlan[]> => {
	const response = await HttpService.get(`api/v1/subscription-plans/type/${typeId}`, true, { "x-custom-lang": "en" });
	return response;
};
